import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import List from "../../components/list";
import Footer from "../../components/footer";
import PlayYoutube from "../../components/youtube";
import Loading from "../../components/loading";
import "./style.css";

export default function Videos() {
	const navigate = useNavigate();
	const params = useParams();
	const [loading, setLoading] = useState(false);
	const [videos, setVideos] = useState([]);
	const [descricao, setDescricao] = useState("");
	const [viewVideo, setViewVideo] = useState(false);
	const [link, setLink] = useState("");
	const [onLoading, setOnLoading] = useState(false);

	useEffect(() => {
		try {
			setOnLoading(true);

			api.get("v1/videos", {
				params: {
					identificador: params.id,
				},
				headers: {
					banco: "bdsz",
				},
			})
				.then((response) => {
					if (response.status == 200) {
						setVideos(response.data);
						setDescricao(response.data[0].descricao);
						setLink(response.data[0].link);
						setViewVideo(true);
					} else {
						setLoading(false);
					}

					setLoading(false);
				})
				.catch((err) => {
					setLoading(false);
				});
		} finally {
			setOnLoading(false);
		}
	}, []);

	function Voltar() {
		navigate("/videos");
	}

	return (
		<div className="container-fluid video-container mt-5">
			<div className="d-flex justify-content-between align-items-center">
				<h4 className="mt-3 mb-3">{descricao}</h4>
				<button className="btn btn-sm btn-primary" onClick={(e) => Voltar()}>
					Voltar
				</button>
			</div>

			{onLoading ? (
				<Loading mensagem="Carregando Vídeos" />
			) : (
				<div className="video-content row">
					<div className="terr">{viewVideo ? <PlayYoutube startVideoLink={link} vid={videos} /> : null}</div>

					<div className="mt-4 d-flex flex-wrap">
						{videos.map((video) => {
							return (
								<List //
									key={video.id}
									assunto={video.assunto}
									id={video.id}
									link={video.link}
									url_foto={video.url_foto}
									titulo={video.titulo}
									setLink={setLink}
									setViewVideo={setViewVideo}
								/>
							);
						})}
					</div>
				</div>
			)}

			<footer>
				<Footer />
			</footer>
		</div>
	);
}
